var OCS = OCS || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Interfaces = OCS.Advisories.Interfaces || {};
OCS.Advisories.Interfaces.AdvSig = {
    adv_significance_strings: {
        "W": "Warning",
        "A": "Watch",
        "Y": "Advisory",
        "S": "Statement",
        "F": "Forecast",
        "O": "Outlook",
        "N": "Synopsis"
    }
};
/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = OCS.Advisories.Interfaces.AdvSig.adv_significance_strings;
    }
} catch(e) {
    
}